function capitalizeFirstLetter(str) {
    if (!str) {
      return ""; // Handle empty or null strings
    }
    // Convert the first character to uppercase and append the rest of the string in lowercase
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function capitalizeEachWord(str) {
  // Convert the string to lowercase, split into an array of words
  const words = str?.toLowerCase().split(' ');

  // Map over the words array and capitalize the first letter of each
  const capitalizedWords = words?.map(word => {
    if (word.length === 0) return ''; // Handle potential extra spaces
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  // Join the array of words back into a single string with spaces
  return capitalizedWords?.join(' ');
}

const eventStatus = (startDate,endDate) => {
  console.log("START TIME --> ", startDate);
  console.log("END TIME --> ", endDate)
  const currDate = new Date();
  if(startDate && currDate.toString() < startDate.toString()){
    return "Upcoming";
  } else if(startDate && endDate && startDate.toString() < currDate.toString() && currDate.toString() < endDate.toString()){
    return "Ongoing";
  } else if(endDate && endDate.toString() < currDate.toString()){
    return "Completed";
  } else {
    return "Ongoing";
  }
}

module.exports = {
    capitalizeFirstLetter,
    capitalizeEachWord,
    eventStatus
}